import { MdOutlineEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

import "./footerStyle.css"
import Logo from "../navbar/subcomponents/logo/logo";

export default function Footer( {email, whatsapp, linkedin} ) {

    const ano = new Date().getFullYear();

    const screenWidth = window.innerWidth; 

    if (screenWidth < 1025)
        return (
            <footer className="footer-container">
                <div className="footer-upper-part">
                    
                    <div className="Logo">
                        <Logo />
                    </div>
                    <div className="icons-container">
                        <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer"><MdOutlineEmail className="icon-link" color="#1B6DC3"/></a>
                        <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer"><FaWhatsapp className="icon-link" color="#1B6DC3"/></a>
                        <a href={linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin className="icon-link" color="#1B6DC3"/></a>
                    {/* <a href="mailto:email@provedor.com.br?subject=Assunto do email&cc=copia@provedor.com.br&bcc=copiaoculta@provedor.com.br&body=Conteúdo do email que será preenchido automaticamente">Enviar email</a> */}
                    </div>
                    <div className="organization-infos">
                        <p className="info-text">Rua Alfredo Lopes, 1717 - Sala E13.</p>
                        <p className="info-text">Jardim Macarenco</p>
                        <p className="info-text">13560-460</p>
                        <p className="info-text">São Carlos - SP - Brasil</p>
                    </div>
                    <div className="organization-infos">
                        <p className="info-text">E-mail: {email}</p>
                        <p className="info-text">Whats App: +{whatsapp?.substring(0,2)} {whatsapp?.substring(2,4)} {whatsapp?.substring(4,9)}-{whatsapp?.substring(9,13)}</p>
                    </div>
                </div>
                <div className="footer-lower-part">
                    <p>&copy; {ano} BIMAFI. Todos os direitos reservados.</p>
                </div>
            </footer>
        );
    
    return (
        <footer className="footer-container">
            <div className="footer-upper-part">
                <div className="contact">
                    
                    <div className="organization-infos">
                        <div className="icons-container">
                            <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer"><MdOutlineEmail className="icon-link" color="#1B6DC3"/></a>
                            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer"><FaWhatsapp className="icon-link" color="#1B6DC3"/></a>
                            <a href={linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin className="icon-link" color="#1B6DC3"/></a>
                        {/* <a href="mailto:email@provedor.com.br?subject=Assunto do email&cc=copia@provedor.com.br&bcc=copiaoculta@provedor.com.br&body=Conteúdo do email que será preenchido automaticamente">Enviar email</a> */}
                        </div>
                        <p className="info-text">E-mail: {email}</p>
                        <p className="info-text">Whats App: +{whatsapp?.substring(0,2)} {whatsapp?.substring(2,4)} {whatsapp?.substring(4,9)}-{whatsapp?.substring(9,13)}</p>
                    </div>

                    <div className="organization-infos">
                        <p className="info-text">Rua Alfredo Lopes, 1717 - Sala E13.</p>
                        <p className="info-text">Jardim Macarenco</p>
                        <p className="info-text">13560-460</p>
                        <p className="info-text">São Carlos - SP - Brasil</p>
                    </div>

                    <div className="Logo">
                        <Logo />
                    </div>
                </div>
                
            </div>
            <div className="footer-lower-part">
                <p>&copy; {ano} BIMAFI. Todos os direitos reservados.</p>
            </div>
        </footer>
    );
}
